import Button from "@app/components/move2Library/Button/Button"
import { Checkbox } from "@app/components/move2Library/Checkbox/Checkbox"
import Input from "@app/components/move2Library/Input/Input"
import { useRaiseError } from "@app/store/actions/errorActions"
import { useGetStrings } from "@app/store/service/cmsService"
import { useEditUserTranspoderData, useSaveUserTransponder } from "@app/store/service/connectorService"
import { emailPattern } from "@app/utils/validations"
import { useCallback } from "react"
import { useForm } from "react-hook-form"
import "./AddTransponder.css"
export const AddTransponder = ({ defaultTransponder, refetch }) => {
	const [saveTransponder] = useSaveUserTransponder()
	const [saveNewDefault] = useEditUserTranspoderData()

	const { data: strings } = useGetStrings()
	const {
		transponderModalNewLinkTitle,
		transponderModalHelpText,
		transponderModalSubText,

		buttonAddTransponder,

		errorInputMissingEmail,
		errorInputMissingFirstName,
		errorInputMissingLastName,
		errorInputInvalidEmail,

		labelTransponderNumber,
		placeholderFirstName,
		placeholderLastName,
		placeholderBirthday,
		placeholderEMail,
	} = strings ? strings : {}

	const raiseError = useRaiseError()
	const {
		register,
		handleSubmit,
		formState: { errors },
		setValue,
	} = useForm({
		mode: "onTouched",
		defaultValues: {
			scanCode: "",
			firstName: "",
			lastName: "",
			email: "",
			birthDate: "",
			isDefault: false,
		},
	})
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const addTransponder = useCallback(async () => {
		handleSubmit(async data => {
			if (data.isDefault === "on") data.isDefault = true
			data.birthDate = new Date(data.birthDate)

			if (data.isDefault && defaultTransponder) {
				let temp = { ...defaultTransponder }
				temp.isDefault = false
				saveNewDefault(temp)
			}

			saveTransponder(data)
				.unwrap()
				.then(() => {
					setValue("scanCode", "")
					setValue("firstName", "")
					setValue("lastName", "")
					setValue("email", "")
					setValue("birthDate", "")
					setValue("isDefault", false)
					refetch()
				})
				.catch(e => {
					raiseError(e)
				})
		})()
	})
	return (
		<div className="mt-5">
			<h3 className="mb-2">{transponderModalNewLinkTitle}</h3>

			<p className="color-fg-default f5 mb-1">{transponderModalHelpText}</p>
			<p className="color-fg-default f5 regular mb-3">{transponderModalSubText}</p>

			{/* <Input type="radio" label={"Haupttransponder"} formRegister={register("isDefault")} errors={errors}></Input> */}
			<Checkbox className="primary" label="Haupttransponder" formRegister={register("isDefault", {})} errors={errors} />

			<div className="flex flex-column">
				<div className="addTransponder__inputRow addTransponder__inputRow--2 flex flex-items-center">
					<div className="flex-self-baseline">
						<Input
							name="transponderNumber"
							type="text"
							label={labelTransponderNumber + "*"}
							formRegister={register("scanCode", {
								required: {
									value: true,
									message: errorInputMissingFirstName,
								},
							})}
							errors={errors}
						/>
					</div>
					<div className="flex-self-baseline">
						<Input
							name="firstname"
							type="text"
							label={placeholderFirstName + "*"}
							autocomplete="given-name"
							formRegister={register("firstName", {
								required: {
									value: true,
									message: errorInputMissingFirstName,
								},
							})}
							errors={errors}
						/>
					</div>
				</div>
				<div className="addTransponder__inputRow addTransponder__inputRow--2">
					<div className="flex-self-baseline">
						<Input
							name="lastname"
							type="text"
							label={placeholderLastName + "*"}
							formRegister={register("lastName", {
								required: {
									value: true,
									message: errorInputMissingLastName,
								},
							})}
							errors={errors}
						/>
					</div>
					<div className="flex-self-baseline">
						<Input
							name="birthDate"
							type="date"
							label={placeholderBirthday + "*"}
							placeholder="dd.mm.yyyy"
							formRegister={register("birthDate", {
								required: {
									value: true,
								},
							})}
							errors={errors}
						/>
					</div>
				</div>
				<div className="addTransponder__inputRow addTransponder__inputRow--2">
					<div className="flex-self-baseline">
						<Input
							name="email"
							type="text"
							label={placeholderEMail + "*"}
							formRegister={register("email", {
								required: {
									value: true,
									message: errorInputMissingEmail,
								},
								pattern: {
									value: emailPattern,
									message: errorInputInvalidEmail,
								},
							})}
							errors={errors}
						/>
					</div>
					<div />
				</div>
			</div>
			<Button style="secondary" onClick={addTransponder} className="mt-3">
				{" "}
				{buttonAddTransponder}{" "}
			</Button>
		</div>
	)
}
